import Link from "next/link";

export default function SectionTitle({
  title,
  href,
  linkLabel,
  className = "",
}: {
  title: string;
  href?: string;
  linkLabel?: string;
  className?: string;
}) {
  return (
    <div
      className={`flex items-center justify-between gap-6 ${className}`}
    >
      <h2 className="text-[28px] font-semibold leading-[1.2] tracking-[-0.6px] text-accent sm:text-[36px] sm:leading-[1.15] lg:text-[44px] lg:leading-[60px] lg:tracking-[-1px]">
        {title}
      </h2>
      {href && linkLabel && (
        <Link
          href={href}
          className="hidden h-12 items-center justify-center rounded-xl bg-white px-5 text-[16px] leading-6 text-accent transition hover:bg-surface-2 sm:flex"
        >
          {linkLabel}
        </Link>
      )}
    </div>
  );
}
